import React, { useEffect, useRef, useState } from 'react';
import Button from './Button';
import { cn } from './cn';

/** Vertical widget sizing. The caller owns saved height and snap targets. */
export default function Resizable({ height, minHeight = 100, snapHeights = [], enabled = false, onResize, label = 'Resize panel', children, className }) {
  const [draft, setDraft] = useState(null);
  const start = useRef(null);
  const current = useRef(null);
  const callback = useRef(onResize);
  callback.current = onResize;
  useEffect(() => {
    if (!enabled) return undefined;
    const move = event => {
      if (!start.current) return;
      const next = Math.max(minHeight, start.current.height + event.clientY - start.current.y);
      const snapped = snapHeights.find(value => Math.abs(next - value) < 15);
      current.current = snapped || Math.round(next / 10) * 10;
      setDraft(current.current);
    };
    const finish = () => {
      if (!start.current) return;
      start.current = null;
      if (current.current != null) callback.current?.(current.current);
      current.current = null;
      setDraft(null);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', finish);
    window.addEventListener('pointercancel', finish);
    return () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', finish);
      window.removeEventListener('pointercancel', finish);
    };
  }, [enabled, minHeight, snapHeights]);
  return <div className={cn('relative min-w-0', className)} style={height ? { height: draft ?? height } : undefined}>
    {children}
    {enabled && <Button variant="ghost" aria-label={label} className="absolute inset-x-0 bottom-0 h-3 w-full min-h-3 cursor-ns-resize touch-none rounded-t-none p-0"
      onPointerDown={event => { event.preventDefault(); start.current = { y: event.clientY, height }; }}
      onKeyDown={event => { if (event.key === 'ArrowUp' || event.key === 'ArrowDown') { event.preventDefault(); onResize(Math.max(minHeight, height + (event.key === 'ArrowDown' ? 10 : -10))); } }}>
      <span className="h-1 w-10 rounded-full bg-bun-line-strong" />
    </Button>}
  </div>;
}
